module.exports = __webpack_public_path__ + "static/media/human-male.bd9b3350.png";